// 运维
export default [
  // 附加服务
  {
    path: '/option',
    name: 'option',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/option/index'),
    meta: {
      activeMenu: 'option', // 可用选中菜单
    }
  },
  // 国际物流
  {
    path: '/logistics',
    name: 'logistics',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/logistics/index'),
    meta: {
      activeMenu: 'logistics', // 可用选中菜单
    }
  },
  // banner

  {
    path: '/menu3_config_banner',
    name: 'menu3_config_banner',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/banner/index'),
    meta: {
      activeMenu: 'menu3_config_banner', // 可用选中菜单
    }
  },
  // 品名材质维护

  {
    path: '/menu3_config_material',
    name: 'menu3_config_material',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/materialMaintain/index'),
    meta: {
      activeMenu: 'menu3_config_material', // 可用选中菜单
    }
  },
  // 分类管理

  {
    path: '/menu3_config_cate',
    name: 'menu3_config_cate',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/classificationManagement/index'),
    meta: {
      activeMenu: 'menu3_config_cate', // 可用选中菜单
    }
  },
  // 首页预览

  {
    path: '/menu3_config_homepage',
    name: 'menu3_config_homepage',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/homepage/index'),
    meta: {
      activeMenu: 'menu3_config_homepage', // 可用选中菜单
    }
  },
  // 通知公告

  {
    path: '/menu3_config_notice',
    name: 'menu3_config_notice',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/notice/index'),
    meta: {
      activeMenu: 'menu3_config_notice', // 可用选中菜单
    }
  },
  // 关键词维护

  {
    path: '/menu3_config_keywords_search',
    name: 'menu3_config_keywords_search',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/keywordMaintain/index'),
    meta: {
      activeMenu: 'menu3_config_keywords_search', // 可用选中菜单
    }
  },
  // 违禁品维护

  {
    path: '/menu3_config_goods_monitor',
    name: 'menu3_config_goods_monitor',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/contrabandSurveillance/index'),
    meta: {
      activeMenu: 'menu3_config_goods_monitor', // 可用选中菜单
    }
  },
  // 客户评价
  {
    path: '/customerEvaluation',
    name: 'customerEvaluation',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/customerEvaluation/index'),
    meta: {
      activeMenu: 'customerEvaluation', // 可用选中菜单
    }
  },
  // 意见反馈
  {
    path: '/opinionFeedback',
    name: 'opinionFeedback',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/opinionFeedback/index'),
    meta: {
      activeMenu: 'opinionFeedback', // 可用选中菜单
    }
  },
  // 意见反馈
  {
    path: '/menu3_config_goods_attr',
    name: 'menu3_config_goods_attr',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/commoditySpecificationMaintenance/index'),
    meta: {
      activeMenu: 'menu3_config_goods_attr', // 可用选中菜单
    }
  },
  // commodityCommission
  {
    path: '/commodityCommission',
    name: 'commodityCommission',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/commodityCommission/index'),
    meta: {
      activeMenu: 'commodityCommission', // 可用选中菜单
    }
  },
  // 仓库地址维护
  {
    path: '/addressWarehouse',
    name: 'addressWarehouse',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/addressWarehouse/index'),
    meta: {
      activeMenu: 'addressWarehouse', // 可用选中菜单
    }
  },
  // APP版本控制
  {
    path: '/APPversions',
    name: 'APPversions',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/APPversions/index'),
    meta: {
      activeMenu: 'APPversions', // 可用选中菜单
    }
  },
  // 日历管理
  {
    path: '/calendarManagement',
    name: 'calendarManagement',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/calendarManagement/index'),
    meta: {
      activeMenu: 'calendarManagement', // 可用选中菜单
    }
  },

  // QA管理
  {
    path: '/qaManage',
    name: 'qaManage',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/qaManage/index'),
    meta: {
      activeMenu: 'qaManage', // 可用选中菜单
    }
  },
  // 网站更新日志
  {
    path: '/websiteUpdates',
    name: 'websiteUpdates',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/websiteUpdates/index'),
    meta: {
      activeMenu: 'websiteUpdates', // 可用选中菜单
    }
  },
  // 聊天信息总汇
  {
    path: '/chatSummary',
    name: 'chatSummary',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/chatSummary/index'),
    meta: {
      activeMenu: 'chatSummary', // 可用选中菜单
    }
  },

  // 投诉配置
  {
    path: '/complaintConfiguration',
    name: 'complaintConfiguration',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/complaintConfiguration/index'),
    meta: {
      activeMenu: 'complaintConfiguration', // 可用选中菜单
    }
  },
  // 榜单维护
  {
    path: '/listMaintenance',
    name: 'listMaintenance',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/listMaintenance/index'),
    meta: {
      activeMenu: 'listMaintenance', // 可用选中菜单
    }
  },
  // 新手指南
  {
    path: '/guide',
    name: 'guide',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/guide/index'),
    meta: {
      activeMenu: 'guide', // 可用选中菜单
    },

  },
  // 新手指南H5
  {
    path: '/guideH5',
    name: 'guideH5',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/guideH5/index'),
    meta: {
      activeMenu: 'guideH5', // 可用选中菜单
    },

  },
  // 自定义商品
  {
    path: '/customizedProducts',
    name: 'customizedProducts',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/customizedProducts/index'),
    meta: {
      activeMenu: 'customizedProducts', // 可用选中菜单
    },

  },
  // 聊天记录
  {
    path: '/chatHistory',
    name: 'chatHistory',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/chatHistory/index'),
    meta: {
      activeMenu: 'chatHistory', // 可用选中菜单
    },

  },
  // 国際送料　簡易比較
  {
    path: '/logisticsIntroduction',
    name: 'logisticsIntroduction',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/logisticsIntroduction/index'),
    meta: {
      activeMenu: 'logisticsIntroduction', // 可用选中菜单
    },

  },
  // option说明'
  {
    path: '/optionDescription',
    name: 'optionDescription',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/optionDescription/index'),
    meta: {
      activeMenu: 'optionDescription', // 可用选中菜单
    },

  },
  // 推荐商品维护
  {
    path: '/recommendedProducts',
    name: 'recommendedProducts',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/recommendedProducts/index'),
    meta: {
      activeMenu: 'recommendedProducts', // 可用选中菜单
    },

  },
  // 底价配置-列表
  {
    path: '/basePriceConfigurationList',
    name: 'basePriceConfigurationList',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/basePriceConfigurationList/index'),
    meta: {
      activeMenu: 'basePriceConfigurationList', // 可用选中菜单
    },

  },
  // 问题登记列表
  {
    path: '/issueRegistrationList',
    name: 'issueRegistrationList',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/issueRegistrationList/index'),
    meta: {
      activeMenu: 'issueRegistrationList', // 可用选中菜单
    },
  },
  // api管理
  {
    path: '/apiManagement',
    name: 'apiManagement',
    component: () => import( /* webpackChunkName: "siteConfiguration" */ '@/views/home/siteConfiguration/apiManagement/index'),
    meta: {
      activeMenu: 'apiManagement', // 可用选中菜单
    },
  }
]